module.exports = __webpack_public_path__ + "static/img/wisdom.925ef452.png";